var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79055 9.40742L0.086732 2.35451C-0.0289107 2.23284 -0.0289107 2.03543 0.086732 1.91376L1.34369 0.591328C1.45943 0.469557 1.64697 0.469557 1.76271 0.591328L7.00001 6.10144L12.2373 0.591328C12.353 0.469557 12.5406 0.469557 12.6563 0.591328L13.9132 1.91376C14.0289 2.03543 14.0289 2.23284 13.9132 2.35451L7.20947 9.40742C7.09215 9.53086 6.90787 9.53086 6.79055 9.40742Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.81a2fcb14162459352e087905e5d596a.svg";
export { ForwardRef as ReactComponent };